import {
  ScheduledOfferPromoType,
  ScheduledOfferState,
} from './ScheduledOfferModel';

/**
 * Figures shared by every level of the report. Money comes as decimal strings,
 * like the rest of the API. Gross includes VAT, net does not; the discount is
 * what the promotion took off, as a positive amount.
 */
export interface PromoResultsMetrics {
  subscribers: number;
  orders: number;
  gross_revenue: string;
  net_revenue: string;
  discount_inc_tax: string;
  discount_exc_tax: string;
}

export interface PromoResultsRow extends PromoResultsMetrics {
  id: number;
  name: string;
  promo_type: ScheduledOfferPromoType;
  promo_type_display: string;
  description: string;
  store: number;
  store_name: string;
  country: string;
  currency_symbol: string;
  state: ScheduledOfferState;
  valid_from: string;
  valid_until: string;
  /** Orders of this promotion that also carry another promotion. */
  orders_with_other_promos: number;
}

export interface PromoResultsTotals extends PromoResultsMetrics {
  /** Orders counted once in the totals although they carry several promotions. */
  orders_with_several_promos: number;
}

export interface PromoResultsMarket extends PromoResultsMetrics {
  country: string;
}

export interface PromoResultsSummary {
  results: PromoResultsRow[];
  totals: PromoResultsTotals;
  by_market: PromoResultsMarket[];
}

export interface PromoResultsOrder {
  id: number;
  code: string;
  state: string;
  charge_date: string | null;
  user: number;
  user_email: string;
  country: string;
  gross_revenue: string;
  net_revenue: string;
  discount_inc_tax: string;
  discount_exc_tax: string;
  other_promos: { id: number; name: string | null }[];
}

export interface PromoResultsDetail extends PromoResultsRow {
  order_list: {
    count: number;
    next: string | null;
    previous: string | null;
    results: PromoResultsOrder[];
  };
}

/** Dates as YYYY-MM-DD; they filter orders by charge date, both ends included. */
export interface PromoResultsDateFilters {
  date_from?: string;
  date_to?: string;
}

export interface PromoResultsFilters extends PromoResultsDateFilters {
  /** Comma separated country codes, e.g. "ES,FR,PT". */
  country?: string;
  promo_type?: ScheduledOfferPromoType;
  state?: ScheduledOfferState;
}

/** Markets the mini-shop promotions are reported for. All of them bill in euros. */
export const PROMO_RESULTS_MARKETS = ['ES', 'FR', 'PT'];

export const PROMO_RESULTS_ORDERS_PER_PAGE = 20;
